import { Component } from 'preact'
import { extractRenderPropsChildren } from '../../../libs/renderProps'
import InputGroup from '../../ui-components/InputGroup'
import { BaseFilterSelectorBuilderData, FilterSelectorProps } from './interfaces'
import { FilterOptionItem } from '@insided/deprecated-control/overview/filters/FilterOption'
import { FilterSelector } from '@insided/deprecated-control/overview/filters/FiltersMenu'

interface CommonProps {
  items: FilterOptionItem[]
}

type BuilderData = BaseFilterSelectorBuilderData & CommonProps

type Filter = FilterSelector & CommonProps

type Props = FilterSelectorProps<string | number | boolean> & CommonProps

interface State {
  data: string | number | boolean | null
}

class RadioFilterSelector extends Component<Props, State> {
  static create = (config: BuilderData): Filter => {
    const { items, ...rest } = config
    return {
      component: this,
      type: 'filter',
      getPillDisplayValue: (data: string): string => {
        const selectedItem = items.find((item) => item.value === data)

        return selectedItem?.name || ''
      },
      items,
      ...rest
    }
  }

  constructor(props: Props) {
    super(props)
    this.state = {
      data: typeof props.selectedFilterItems !== 'undefined' ? props.selectedFilterItems : null
    }
  }

  setData = (data: string | number | boolean) => {
    this.setState({ data })
  }

  render() {
    const { name, items, children } = this.props
    const { data } = this.state

    return (
      <div>
        <div className='overview__filters-box-content'>
          {items.map((item) => {
            const checked = data === item.value
            return (
              <div key={item.id}>
                <InputGroup
                  inline
                  name={name}
                  value={String(item.value)}
                  title={item.name}
                  type='radio'
                  formGroupClasses='overview__filters-box-filter'
                  checked={checked}
                  onChange={() => this.setData(item.value)}
                />
              </div>
            )
          })}
        </div>
        {extractRenderPropsChildren(children)({
          data,
          isApplyButtonDisabled: data === null
        })}
      </div>
    )
  }
}

export default RadioFilterSelector
